<template>
  <div class="work-flow-card-wrapper">
    <div
      class="tag-overlay"
      v-if="isTagModalVisible"
      @click="closeTagModal"
    ></div>
    <div
      class="item-wrapper card"
      :style="{ zoom: getZoom }"
      :class="{
        checked: isFlowCardSelected,
        'tag-modal-close': !isTagModalVisible,
        'tag-modal-open': isTagModalVisible,
      }"
      @mouseenter="onCardHover(true)"
      @mouseleave="onCardHover(false)"
      :key="process.id"
    >
      <div
        v-if="isTagModalVisible"
        class="modal-inner add-tag-modal-wrapper"
        :class="{ 'tag-modal-inner-open': isTagModalVisible }"
        @click="hideListOnBlur"
      >
        <div class="loading-container" v-if="addTag.isTagLoading">
          <LoadingSpinner />
        </div>

        <div class="custom-multiselect" :class="{ open: addTag.isListOpen }">
          <div class="custom-multiselect-wrap">
            <div class="custom-selected-tags">
              <div
                class="custom-selected-tags-wrap"
                ref="tagsInputRef"
                @click.stop="openList()"
              >
                <div
                  class="custom-selected-item selected-item"
                  v-for="(tag, index) in addTag.selectedTag"
                  :key="tag.tagName"
                  :style="{ 'background-color': tag.tagColor }"
                >
                  <span>{{ tag.tagName }}</span>
                  <i
                    class="fa fa-times"
                    @click.stop="removeTagList(tag, index)"
                  ></i>
                </div>
                <div class="custom-selected-item input">
                  <input
                    type="text"
                    name="group-name"
                    ref="tagNameInput"
                    @focus="openList()"
                    @click="openList()"
                    @keyup="handelKeyUp"
                    autocomplete="off"
                    :value="addTag.searchTag"
                  />
                </div>
              </div>
            </div>
            <div
              class="custom-multiselect-list"
              :class="{ open: addTag.isListOpen }"
              ref="tagsListRef"
              v-if="
                addTag.isNewTag ||
                addTag.isColorsListOpen ||
                getFilteredTagList.length > 0
              "
            >
              <div class="custom-multiselect-list-wrap">
                <div
                  :class="[
                    'custom-multiselect-list-item',
                    { 'select-div-visible': addTag.isColorsListOpen },
                  ]"
                  v-if="addTag.isNewTag && addTag.searchTag !== ''"
                  @click.stop="openColorsList()"
                >
                  <div class="custom-multiselect-list-item-inner">
                    <span class="tag-name">
                      {{ `Tag ${addTag.searchTag} Erstellen` }}
                    </span>
                  </div>
                </div>
                <div
                  v-if="addTag.isColorsListOpen"
                  :class="[
                    'custom-multiselect-list-item',
                    { 'select-div-visible': addTag.isColorsListOpen },
                  ]"
                >
                  <div class="custom-multiselect-list-item-inner">
                    <div class="colors-tags-list-wrapper">
                      <div
                        class="colors-Tag-list-item"
                        v-for="colorName in addTag.tagColorsList"
                        :style="{
                          'background-color': colorName,
                        }"
                        :key="colorName"
                        @click.stop="createNewTag(colorName)"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="custom-multiselect-list-item-wrapper">
              <div
                class="custom-multiselect-list-item inside-tag-list-item"
                v-for="(tag, tagIndex) in getFilteredTagList"
                :key="`${tag.tagName}_${tagIndex}`"
                @click.stop="selectTag(tag)"
              >
                <div class="custom-multiselect-list-item-inner">
                  <span
                    class=""
                    :style="{
                      'background-color': tag.tagColor,
                    }"
                  >
                    {{ tag.tagName }}
                  </span>
                </div>
                <div
                  class="edit-action-icon"
                  :id="`edit-action-trigger`"
                  @click.stop="($event) => onClickTagEdit($event, tag)"
                >
                  <i class="fas fa-ellipsis-h ellipsis-icon"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div
          class="data-dz-thumbnail-bg-overlay loading custom-loader"
          v-if="showLoadingOverlay.includes(process.id)"
        >
          <div class="progress-status"></div>
          <div class="progress-icon"></div>
        </div>
        <div class="header">
          <input
            type="checkbox"
            name="select"
            id="multiple-select"
            v-if="!isPreviewSection"
            @click="onFlowSelect($event, process)"
            :checked="isFlowCardSelected"
          />
          <ul
            class="tools"
            v-if="!isPolicyStatusPending(process) && !isPreviewSection"
          >
            <li
              v-if="
                process.type != 'action' &&
                process.access_level != workFlowAccessLevel.EDIT_CONTENT
              "
              class="embed"
              title="Einbetten"
              @click="getWorkFlowData(process)"
            >
              <img
                src="../../assets/img/code-tag.svg"
                alt="code"
                class="code-tag-icon"
              />
              <p v-show="embedCodeCopied === process.id" class="message">
                Kopiert!
              </p>
            </li>
            <li
              data-dz-delete
              v-if="process.access_level != 'owner'"
              class="leave"
              title="Verlassen"
              v-on:click="requestLeaveConfirmation(process)"
            >
              <img src="../../assets/img/quit.svg" alt="quit" />
            </li>
            <li
              class="download"
              title="Download"
              v-on:click="downloadFlowAsJson(process.id)"
              v-if="
                process.access_level != workFlowAccessLevel.EXECUTE &&
                process.access_level != workFlowAccessLevel.EDIT_CONTENT
              "
            >
              <img src="../../assets/img/download.svg" alt="download" />
            </li>
            <li
              data-dz-delete
              v-if="
                process.access_level != workFlowAccessLevel.EXECUTE &&
                process.access_level != workFlowAccessLevel.EDIT_CONTENT
              "
              title="Duplizieren"
              class="duplicate"
              v-on:click="duplicateElement(process)"
            >
              <img src="../../assets/img/duplicate.svg" alt="duplicate" />
            </li>
            <li
              data-dz-delete
              v-if="
                process.access_level != 'execute' &&
                process.access_level != workFlowAccessLevel.EDIT_CONTENT
              "
              title="Löschen"
              class="delete"
              v-on:click="requestRemoveConfirmation(process)"
            >
              <img src="../../assets/img/delete-icon.svg" alt="delete" />
            </li>
            <li
              class="share"
              title="Teilen"
              v-if="!['execute', 'edit-content'].includes(process.access_level)"
              v-on:click="showShareFlow(process)"
            >
              <img src="../../assets/img/user.svg" alt="share" />
            </li>
          </ul>
        </div>
        <div class="content">
          <h1
            class="flow-title main-title"
            type="text"
            ref="workFlowHeader"
            @click="setEditMode"
            :contenteditable="isEditMode"
            @blur="editWorkFlowName($event, process.id)"
            @keydown.enter="(e) => e.preventDefault()"
          >
            {{ process.name }}
          </h1>
          <div
            class="tag-wrapper"
            v-if="addTag.isTagVisible && !isTagModalVisible"
          >
            <div
              class="workflow-tag-list"
              v-if="
                getTagsPerWorkflow &&
                getTagsPerWorkflow[process.id] &&
                getTagsPerWorkflow[process.id].length > 0
              "
            >
              <div
                class="workflow-tag"
                v-for="(tag, index) in isShowAllTag(process.id)"
                :style="{ backgroundColor: tag.color }"
              >
                {{ tag.name }}
                <div
                  v-if="!isPreviewSection"
                  class="remove-tag-icon"
                  :style="{
                    backgroundImage: `linear-gradient(to right, rgba(255, 0, 0, 0), ${tag.color} 68%)`,
                  }"
                >
                  <i
                    class="fa fa-times"
                    @click="removeTagListfromOutside(tag, index, process.id)"
                  ></i>
                </div>
              </div>
              <div
                class="more-tags-wrapper"
                v-if="
                  getTagsPerWorkflow[process.id].length > 2 && !isCardHovered
                "
              >
                +{{ getTagsPerWorkflow[process.id].length - 2 }} more
              </div>
            </div>
            <div
              class="custom-add-tags"
              @click="openModal(process)"
              v-if="isCardHovered && filter !== 'requests' && !isPreviewSection"
            >
              <img src="../../assets/img/add-tag.svg" alt="add" />
            </div>
          </div>
          <div class="worflow-tag-list-wrapper"></div>
        </div>
        <div :id="`tooltip-${process.id}`" class="footer">
          <template v-if="!isPolicyStatusPending(process)">
            <button
              v-if="process.access_level != 'execute' && !isPreviewSection"
              class="btn"
              :class="{ 'disable-btn': isEditbuttonDisable }"
              v-b-tooltip.hover="editButtonToolTip"
              @click="onClickWorkflowEdit"
            >
              Bearbeiten
            </button>
            <router-link
              v-show="process.type != 'action'"
              :to="{
                name: 'process-runner',
                params: {
                  id: process.id,
                },
              }"
              class="btn run-process"
              :class="{ big: process.access_level == 'execute' }"
            >
              Starten
            </router-link>
          </template>
          <template v-if="isPolicyStatusPending(process)">
            <button
              class="btn policy-request-buton"
              @click="onAcceptWorkflow(process.policy_id)"
            >
              Annehmen
            </button>
            <button
              class="btn policy-request-buton"
              @click="onRejectWorkflow(process.policy_id)"
            >
              Ablehnen
            </button>
          </template>
        </div>
      </div>

      <div v-if="editableTag" ref="tagEditModalRef" class="edit-dropdown">
        <div class="edit-dropdown-inner">
          <div class="edit-dropdown-input">
            <input
              v-model="editableTag.tagName"
              :class="{
                'invalid-input': isUpdateTagInputFieldInValid(editableTag),
              }"
              type="text"
            />
          </div>
          <div class="edit-dropdown-bottom">
            <!-- <div class="remove-button-wrapper">
              <div class="remove-button" @click="removeTag">
                <i class="far fa-trash-alt me-1"></i>
                Löschen
              </div>
            </div> -->
            <div class="color-checkbox">
              <p>Farbe auswählen</p>
              <div class="colors-tags-list-wrapper">
                <div
                  class="colors-Tag-list-item"
                  v-for="colorName in addTag.tagColorsList"
                  :style="{
                    'background-color': colorName,
                  }"
                  :class="{
                    'selected-color': editableTag.tagColor === colorName,
                  }"
                  :key="colorName"
                  @click.stop="onChangeColor(colorName)"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { workFlowAccessLevel } from '../../enum/auth.enum';
import {
  createWorkFlowTags,
  deleteTags,
  editWorkFlowTags,
} from '../../services/axios/data.api';
import { getWorkFlowById } from '../../services/workflow.service';
import { getFlowLastId } from '../../utils/helpers';
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'WorkFLowListCard',
  props: {
    process: Object,
    selectedFlows: Array,
    addTag: Object,
    showLoadingOverlay: Array,
    copyEmbedModal: Object,
    resourceType: String | null,
    confirmationModal: Object,
    isShareModalVisible: Boolean,
    flowRequest: Object,
    selectedFlow: Object | null,
    filter: String,
    selectionMsg: Object,
  },
  data() {
    return {
      zoom: 70,
      isCardHoverIndex: null,
      workFlowAccessLevel: workFlowAccessLevel,
      isLoading: false,
      requestError: null,
      isSortActive: true,
      embedCodeCopied: '',
      isTagModalVisible: false,
      workflowTags: [],
      isCardHovered: false,
      isEditMode: false,
      editableTag: null,
    };
  },
  methods: {
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    async getWorkFlowData(workflow) {
      this.copyEmbedModal.selectedFlow = workflow;
      this.copyEmbedModal.visible = true;
      this.copyEmbedModal.loading = true;

      try {
        const response = await this.getFlow(workflow.id);
        if (response.tasks.length > 0) {
          const flowOutput = response.tasks[0].props.formTrigger.elements;
          this.copyEmbedModal.selectedFlow.executionUrl =
            response.settings.apiEndpoint;
          this.copyEmbedModal.elements = flowOutput;
          this.copyEmbedModal.loading = false;
        } else {
          this.showToaster('Kein Schema gefunden', 'Fehler', 'danger');
          throw new Error('no schema provided');
        }
      } catch (error) {
        console.log(error);
        this.closeCopyEmbedModal();
      }
    },
    async getFlow(id) {
      const response = await getWorkFlowById(id);
      if (response && response.status === 200) {
        return response.data;
      }
    },
    closeCopyEmbedModal() {
      this.copyEmbedModal.visible = false;
      this.copyEmbedModal.selectedFlow = {};
      this.copyEmbedModal.elements = [];
      this.copyEmbedModal.loading = false;
    },
    requestLeaveConfirmation(p) {
      this.$emit('setSelectedFlow', p);
      this.$emit('setResourceType', 'flow');
      this.$set(this.confirmationModal, 'actionType', 'leave');
      this.$set(this.confirmationModal, 'isRemoveConfirmationVisible', true);
    },
    requestRemoveConfirmation(p) {
      this.$emit('setAreMultipleFlowsSelected', false);
      this.$emit('setSelectedFlow', p);
      this.$emit('setResourceType', 'flow');
      this.$set(this.confirmationModal, 'actionType', 'remove');
      this.$set(this.confirmationModal, 'isRemoveConfirmationVisible', true);
    },
    async downloadFlowAsJson(id) {
      let process = await this.getFlow(id);

      // Copy and reset owner & tableID
      var deepCopy = Object.assign({}, JSON.parse(JSON.stringify(process)));
      deepCopy.id = getFlowLastId(this);
      deepCopy.owner = '';

      // TODO: Delete if there are no more old flows
      if (deepCopy.hasOwnProperty('tableID')) deepCopy.tableID = '';
      else deepCopy['tableID'] = '';

      // Remove input & output
      deepCopy.tasks.forEach((part, index, arr) => {
        arr[index].output = [];
        arr[index].input = [];
      });

      // Create data string & export
      let dataStr =
        'data:text/json;charset=utf-8,' +
        encodeURIComponent(JSON.stringify(deepCopy));
      let link = document.createElement('a');
      link.setAttribute('href', dataStr);
      link.setAttribute('download', deepCopy.name + '.json');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    duplicateElement(flow) {
      this.$emit('unSelectAll');
      this.$emit('setIsLoading', true);
      var url = process.env.VUE_APP_DATA_API;
      url += '/duplicate-flow/' + flow.id;

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );

      fetch(url, {
        headers: myHeaders,
        method: 'PUT',
      })
        .then((response) => response.json())
        .then(() => {
          // Get all flows
          setTimeout(() => {
            this.$store.dispatch('getFlows');
            this.$store.dispatch('fetchWorkFlowTags');
            this.$emit('setIsLoading', false);
          }, 1000);
        })
        .catch((e) => {
          this.$emit('setIsLoading', false);
          this.requestError = e;
        });
    },
    showShareFlow(p) {
      this.$emit('setAreMultipleFlowsSelected', false);
      this.$emit('setSelectedFlow', p);
      this.$emit('setShareFlowModal', true);
    },
    async updateFlow(id, name) {
      let flow = await this.getFlow(id);
      flow.name = name;
      this.saveProcess(flow, false);
      this.showToaster(
        'Der Workflow-Name wurde erfolgreich geändert!',
        'Erfolgreich',
        'success'
      );
    },
    saveProcess(flow, redirect) {
      this.$store
        .dispatch('saveFlow', {
          flow: flow,
        })
        .then((message) => {
          // Success always returns the ID as number
          if (typeof message == 'number') return message;
          else throw new Error(message);
        })
        .then((id) => {
          if (redirect) {
            this.isLoading = false;
            this.goToProcess(id);
          }
        })
        .catch((e) => {
          this.requestError = e;
        });
    },
    async goToProcess(id) {
      this.$router.push({
        path: '/',
        query: {
          section: 'process-designer',
          process: id,
        },
      });
    },
    isShowAllTag(id) {
      if (this.isCardHovered) {
        this.workflowTags = this.getTagsPerWorkflow[id];
        return this.getTagsPerWorkflow[id];
      }
      return this.getTagsPerWorkflow[id].slice(0, 2);
    },
    openModal(p) {
      this.isTagModalVisible = true;
      this.addTag.isTagLoading = true;
      this.addTag.isTagModalVisible = true;
      this.addTag.selectedTag = [];
      if (
        this.getTagsPerWorkflow &&
        Object.keys(this.getTagsPerWorkflow).length > 0 &&
        this.getTagsPerWorkflow[p.id]
      ) {
        const selectedTags = this.getTagsPerWorkflow[p.id].map((el) => ({
          id: el.id,
          tagName: el.name,
          tagColor: el.color,
          resources: el.resources,
        }));

        this.addTag.selectedTag = selectedTags;
      }
      this.addTag.isTagLoading = false;
    },
    onAcceptWorkflow(flowId) {
      this.flowRequest.isVisibleFlowConfirmation = true;
      this.flowRequest.flowConfirmationMessage =
        this.selectionMsg.single.accept;
      this.flowRequest.requestStatus = 'accepted';
      this.flowRequest.flowId = [flowId];
    },
    onRejectWorkflow(flowId) {
      this.flowRequest.isVisibleFlowConfirmation = true;
      this.flowRequest.flowConfirmationMessage =
        this.selectionMsg.single.reject;
      this.flowRequest.requestStatus = 'rejected';
      this.flowRequest.flowId = [flowId];
    },
    async closeTagModal() {
      if (this.editableTag) {
        this.saveEditTag(this.editableTag);
        this.closeTagEditModal();
      }
      await this.saveTagsInFlow();
    },
    onCardHover(isHovered) {
      this.isCardHovered = isHovered;
    },
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
      });
    },
    async removeTagListfromOutside(tag, tagIndex, flowId) {
      if (this.addTag.isTagLoading) {
        return;
      }
      try {
        this.workflowTags.splice(tagIndex, 1);
        this.addTag.isTagLoading = true;
        await deleteTags(tag.id, `?flow-id=${flowId}`);
        await this.updateStoreForTag(tag, flowId);
      } catch (error) {
        this.showToaster('Fehler beim Löschen des Tags', 'Fehler', 'danger');
      } finally {
        this.addTag.isTagLoading = false;
      }
    },
    async updateStoreForTag(tag, flowId) {
      const workflowsPerTag = JSON.parse(
        JSON.stringify(this.getWorkflowsPerTag)
      );
      const tagsPerWorkflow = JSON.parse(
        JSON.stringify(this.getTagsPerWorkflow)
      );

      const indx = workflowsPerTag.findIndex((ele) => ele.id == tag.id);
      if (indx > -1) {
        workflowsPerTag[indx].resources = workflowsPerTag[
          indx
        ].resources.filter((ele) => ele != flowId);
        if (workflowsPerTag[indx]?.resources?.length == 0) {
          workflowsPerTag.splice(indx, 1);
        }
      }

      tagsPerWorkflow[flowId] = tagsPerWorkflow[flowId].filter(
        (ele) => ele.id !== tag.id
      );

      if (tagsPerWorkflow[flowId] && tagsPerWorkflow[flowId].length == 0) {
        delete tagsPerWorkflow[flowId];
      }

      this.$store.dispatch('setWorkFlowPerTag', workflowsPerTag);
      this.$store.dispatch('setTagPerWorkFlow', tagsPerWorkflow);
    },
    hideListOnBlur(e) {
      const tagsInputRef = this.$refs.tagsInputRef;
      const tagsListRef = this.$refs.tagsListRef;
      if (
        tagsInputRef &&
        tagsListRef &&
        !tagsListRef.contains(e.target) &&
        !tagsInputRef.contains(e.target)
      ) {
        this.addTag.isListOpen = false;
      }
    },
    openList() {
      this.$refs.tagNameInput.focus();
      this.addTag.isListOpen = true;
      if (this.editableTag) {
        this.saveEditTag(this.editableTag);
        this.closeTagEditModal();
      }
    },
    removeTagList(tag, tagIndex) {
      this.$refs.tagNameInput.focus();
      // if (
      //   tag?.newItem &&
      //   !this.addTag.tempTags.some(
      //     (el) => tag.tagName.toLowerCase() == el.tagName.toLowerCase()
      //   )
      // ) {
      //   this.addTag.tempTags.push(tag);
      // }
      this.addTag.selectedTag.splice(tagIndex, 1);
    },
    handelKeyUp(e) {
      this.addTag.searchTag = e.target.value.trim();
      if (this.addTag.searchTag !== '' && this.addTag.searchTag !== ',') {
        const isStringExistInTagList = this.getFlowTagList.some(
          (tagItem) =>
            tagItem.tagName.toLowerCase() == this.addTag.searchTag.toLowerCase()
        );
        const isStringExistInSelectedList = this.addTag.selectedTag.some(
          (tagItem) =>
            tagItem.tagName.toLowerCase() == this.addTag.searchTag.toLowerCase()
        );
        const isStringExistsInTempList = this.addTag.tempTags.some(
          (tagItem) =>
            tagItem.tagName.toLowerCase() == this.addTag.searchTag.toLowerCase()
        );
        if (
          !isStringExistInTagList &&
          !isStringExistInSelectedList &&
          !isStringExistsInTempList
        ) {
          this.addTag.isColorsListOpen = false;
          this.addTag.isNewTag = true;
        } else {
          this.addTag.isNewTag = false;
          this.addTag.isColorsListOpen = false;
        }
      }
      if (this.addTag.searchTag === '') {
        this.addTag.isNewTag = false;
        this.addTag.isColorsListOpen = false;
      }
    },
    openColorsList() {
      this.$refs.tagNameInput.focus();
      this.addTag.isNewTag = false;
      this.addTag.isColorsListOpen = true;
    },
    async createNewTag(colorName) {
      this.$refs.tagNameInput.focus();
      if (this.addTag.searchTag !== '' && colorName != '') {
        this.addTag.searchTag = this.addTag.searchTag.replace(/,/g, '').trim();
        this.addTag.selectedTag.push({
          tagName: this.addTag.searchTag,
          tagColor: colorName,
          newItem: true,
        });
      }
      this.addTag.isColorsListOpen = false;
      this.addTag.searchTag = '';
    },
    async selectTag(addTag) {
      const findTag = this.addTag.selectedTag.find(
        (tag) => tag.id === addTag.id
      );
      if (findTag) return;
      this.addTag.selectedTag.push(addTag);
      this.$refs.tagNameInput.focus();
      this.addTag.searchTag = '';
    },
    async saveTagsInFlow() {
      if (this.addTag.isTagLoading) return;
      try {
        this.addTag.isTagLoading = true;
        this.$refs.tagNameInput.focus();
        const newTags = [];
        const tagsToDelete = [];
        let savedTags = [];

        if (
          this.getTagsPerWorkflow &&
          Object.keys(this.getTagsPerWorkflow).length > 0 &&
          this.getTagsPerWorkflow[this.process.id] &&
          this.getTagsPerWorkflow[this.process.id].length > 0
        ) {
          savedTags = this.getTagsPerWorkflow[this.process.id];
        }

        savedTags.map((el) => {
          const element = this.addTag.selectedTag.find(
            (ele) => ele?.id == el?.id
          );
          if (!element) {
            tagsToDelete.push(el);
          }
        });

        this.addTag.selectedTag.map((el) => {
          const element = savedTags.find((ele) => ele?.id == el?.id);
          if (!element) {
            newTags.push(el);
          }
        });

        if (newTags.length > 0) {
          try {
            const tagsArray = newTags.map((el) => ({
              name: el.tagName,
              color: el.tagColor,
              'flow-id': this.process.id,
              user: this.getUserId,
              'tag-id': el?.id ? el.id : null,
            }));

            const createdTags = await createWorkFlowTags({
              items: JSON.stringify(tagsArray),
            });

            if (
              createdTags &&
              createdTags.status == 200 &&
              createdTags?.data?.tag_data?.length > 0
            ) {
              const workflowsPerTag = JSON.parse(
                JSON.stringify(this.getWorkflowsPerTag)
              );
              const tagsPerWorkflow = JSON.parse(
                JSON.stringify(this.getTagsPerWorkflow)
              );

              const newUpdatedTags = tagsArray.map((el, index) => ({
                color: el.color,
                id: el['tag-id']
                  ? el['tag-id']
                  : createdTags?.data?.tag_data[index]?.id,
                name: el.name,
                resources: createdTags?.data?.tag_data[index]?.resource,
              }));

              newUpdatedTags.map((el) => {
                const workflowsPerTagIndex = workflowsPerTag.findIndex(
                  (ele) => ele.id == el.id
                );

                if (workflowsPerTagIndex > -1) {
                  if (
                    workflowsPerTag[workflowsPerTagIndex]?.resources &&
                    Array.isArray(
                      workflowsPerTag[workflowsPerTagIndex].resources
                    )
                  ) {
                    workflowsPerTag[workflowsPerTagIndex].resources.push(
                      el.resources
                    );
                  } else {
                    workflowsPerTag[workflowsPerTagIndex].resources = [
                      el.resources,
                    ];
                  }
                } else {
                  workflowsPerTag.push({ ...el, resources: [el.resources] });
                }

                if (tagsPerWorkflow[el.resources]) {
                  tagsPerWorkflow[el.resources].push({
                    ...el,
                    resources: [el.resources],
                  });
                } else {
                  tagsPerWorkflow[el.resources] = [
                    { ...el, resources: [el.resources] },
                  ];
                }
              });

              this.$store.dispatch('setWorkFlowPerTag', workflowsPerTag);
              this.$store.dispatch('setTagPerWorkFlow', tagsPerWorkflow);
            }
          } catch (error) {
            console.log(error, 'error');
            throw { message: 'Fehler beim Speichern von Tags' };
          }
        }

        if (tagsToDelete.length > 0) {
          try {
            await Promise.all(
              tagsToDelete.map((el) =>
                deleteTags(el.id, `?flow-id=${this.process.id}`)
              )
            );
            this.updateStoreData(tagsToDelete);
          } catch (error) {
            throw { message: 'Fehler beim Löschen von Tags' };
          }
        }
      } catch (error) {
        let errorMsg;
        this.$store.dispatch('fetchWorkFlowTags');
        if (error?.message) {
          errorMsg = error.message;
        } else {
          errorMsg = error;
        }
        this.showToaster(errorMsg, 'Fehler', 'danger');
      } finally {
        this.isTagModalVisible = false;
        this.addTag.selectedTag = [];
        this.addTag.isTagLoading = false;
        this.addTag.isTagModalVisible = false;
      }
    },
    async updateStoreData(arr) {
      const workflowsPerTag = JSON.parse(
        JSON.stringify(this.getWorkflowsPerTag)
      );
      const tagsPerWorkflow = JSON.parse(
        JSON.stringify(this.getTagsPerWorkflow)
      );

      await arr.map((el) => {
        const indx = workflowsPerTag.findIndex((ele) => ele.id == el.id);
        if (indx > -1) {
          workflowsPerTag[indx].resources = workflowsPerTag[
            indx
          ].resources.filter((ele) => ele != this.process.id);
          if (workflowsPerTag[indx]?.resources?.length == 0) {
            workflowsPerTag.splice(indx, 1);
          }
        }

        tagsPerWorkflow[this.process.id] = tagsPerWorkflow[
          this.process.id
        ].filter((ele) => ele.id !== el.id);

        if (
          tagsPerWorkflow[this.process.id] &&
          tagsPerWorkflow[this.process.id].length == 0
        ) {
          delete tagsPerWorkflow[this.process.id];
        }
      });

      this.$store.dispatch('setWorkFlowPerTag', workflowsPerTag);
      this.$store.dispatch('setTagPerWorkFlow', tagsPerWorkflow);
    },
    isPolicyStatusPending(flow) {
      return flow.policyStatus === 'pending';
    },
    onFlowSelect(event, process) {
      this.$emit('onFlowSelect', event, process);
    },
    setEditMode(e) {
      if (this.isPreviewSection) return;
      e.target.style.overflow = 'unset';
      e.target.style.display = 'inline-block';
      if (this.process.access_level != 'execute') {
        this.isEditMode = true;
        this.$nextTick(() => {
          this.$refs.workFlowHeader.focus();
        });
      }
    },
    editWorkFlowName(e, processId) {
      e.target.removeAttribute('style');
      const workFlowHeader = e.target.innerText?.trim();

      if (!workFlowHeader || workFlowHeader === '') {
        this.showToaster(
          'Bitte geben Sie den Namen des Workflows ein',
          'Fehler',
          'danger'
        );
        e.target.innerText = this.process.name;
        return;
      }
      this.isEditMode = false;
      if (this.process.name !== workFlowHeader) {
        this.process.name = workFlowHeader;
        this.updateFlow(processId, workFlowHeader);
      } else {
        e.target.innerText = this.process.name;
      }
    },
    async onClickTagEdit(event, tag) {
      if (!event?.target || !tag) return;
      if (this.editableTag) {
        await this.saveEditTag(this.editableTag);
      }
      if (this.editableTag?.id === tag.id) {
        this.closeTagEditModal();
        return;
      }
      this.editableTag = { ...tag };
      const editIconrect = event.target?.getBoundingClientRect();
      const cardWrapperRect = document
        .querySelector('.tag-modal-open')
        ?.getBoundingClientRect();
      const editModalTopOffset = editIconrect.bottom - cardWrapperRect.top;

      this.$nextTick(() => {
        const editModalEl = this.$refs.tagEditModalRef;
        editModalEl.style.top = `${editModalTopOffset + 10}px`;
      });
    },
    closeTagEditModal() {
      this.editableTag = null;
    },
    async removeTag() {
      if (!this.editableTag?.id) return;
      try {
        // await deleteTags(this.editableTag.id, `?flow-id=${this.process.id}`);
        // await this.updateStoreData([...this.editableTag]);
        this.closeTagEditModal();
      } catch (error) {
        console.log('error', error);
      }
    },
    async saveEditTag(editableTag) {
      if (!editableTag?.id || this.isUpdateTagInputFieldInValid(editableTag))
        return;
      const findTag = this.getWorkflowsPerTag.find(
        (tag) => tag.id === editableTag.id
      );
      try {
        if (
          !findTag ||
          (findTag.color === editableTag.tagColor &&
            findTag.name === editableTag.tagName)
        )
          return;

        const apiParams = {
          name: editableTag.tagName,
          color: editableTag.tagColor,
        };
        const queryString = new URLSearchParams(apiParams).toString();
        await editWorkFlowTags(editableTag.id, queryString);
        this.updateStoreForEditTag(editableTag);
      } catch (error) {
        console.log('error', error);
      }
    },
    async updateStoreForEditTag(updatedTag) {
      if (!updatedTag) return;
      const workflowsPerTag = JSON.parse(
        JSON.stringify(this.getWorkflowsPerTag)
      );
      const tagsPerWorkflow = JSON.parse(
        JSON.stringify(this.getTagsPerWorkflow)
      );
      const index = this.addTag.selectedTag.findIndex(
        (tag) => tag.id === updatedTag.id
      );
      if (index > -1) {
        this.addTag.selectedTag[index].tagName = updatedTag.tagName;
        this.addTag.selectedTag[index].tagColor = updatedTag.tagColor;
      }
      const findIndex = workflowsPerTag.findIndex(
        (tag) => tag.id === updatedTag.id
      );
      if (findIndex > -1) {
        workflowsPerTag[findIndex].name = updatedTag.tagName;
        workflowsPerTag[findIndex].color = updatedTag.tagColor;
      }
      for (const workflowId in tagsPerWorkflow) {
        tagsPerWorkflow[workflowId] = tagsPerWorkflow[workflowId].map((tag) => {
          if (tag.id === updatedTag.id) {
            return {
              ...tag,
              name: updatedTag.tagName,
              color: updatedTag.tagColor,
            };
          }
          return tag;
        });
      }

      this.$store.dispatch('setWorkFlowPerTag', workflowsPerTag);
      this.$store.dispatch('setTagPerWorkFlow', tagsPerWorkflow);
    },

    onChangeColor(colorName) {
      if (colorName && this.editableTag) this.editableTag.tagColor = colorName;
    },
    isUpdateTagInputFieldInValid(editableTag) {
      const totalTagList = [
        ...this.getFlowTagList,
        ...this.addTag.tempTags,
        ...this.addTag.selectedTag,
      ];

      return totalTagList.some(
        (tag) =>
          tag.id !== editableTag.id &&
          tag.tagName.toLowerCase() === editableTag.tagName.toLowerCase()
      );
    },
    onClickWorkflowEdit() {
      if (this.process.id && !this.isEditbuttonDisable)
        this.goToProcess(this.process.id);
    },
  },
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          const dragging = el.getAttribute('data-dragging');
          // Check that the click was outside the el and its children, and wasn't a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind(el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
  computed: {
    ...mapGetters({
      getUserId: 'getUserId',
      getWorkflowsPerTag: 'getWorkflowsPerTag',
      getTagsPerWorkflow: 'getTagsPerWorkflow',
      getFlowsLoading: 'getFlowsLoading',
    }),
    user() {
      return this.$store.state.user;
    },
    getZoom() {
      return this.zoom / 100;
    },
    getFlowTagList() {
      return this.getWorkflowsPerTag.length
        ? this.getWorkflowsPerTag.map((el) => ({
            id: el.id,
            tagName: el.name,
            tagColor: el.color,
            resources: el.resources,
          }))
        : [];
    },
    getFilteredTagList() {
      const totalTagList = [...this.getFlowTagList, ...this.addTag.tempTags];

      return !this.addTag?.searchTag?.length
        ? totalTagList
        : totalTagList
            .filter((tag) =>
              tag.tagName
                .toLowerCase()
                .includes(this.addTag.searchTag.toLowerCase())
            )
            .sort((a, b) => {
              const previousTag = a.tagName
                .toLowerCase()
                .startsWith(this.addTag.searchTag.toLowerCase());
              const nextTag = b.tagName
                .toLowerCase()
                .startsWith(this.addTag.searchTag.toLowerCase());

              return previousTag === nextTag
                ? a.tagName.toLowerCase().localeCompare(b.tagName.toLowerCase())
                : previousTag
                ? -1
                : 1;
            });
    },
    isFlowCardSelected() {
      return this.selectedFlows.includes(this.process);
    },
    isPreviewSection() {
      return this.$route.query.section === 'preview';
    },
    isEditbuttonDisable() {
      return !!this.process.version && this.process.version >= 3;
    },
    editButtonToolTip() {
      return {
        title:
          'Dieser Workflow ist nicht mit der aktuellen Umgebung kompatibel. Bitte benutzen Sie die neuste Umgebung.',
        container: `tooltip-${this.process.id}`,
        customClass: 'edit-button-tooltip',
        placement: 'top',
        disabled: !this.isEditbuttonDisable,
      };
    },
  },
  components: { LoadingSpinner },
};
</script>
<style scoped>
.item-wrapper:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgb(0 0 0 / 70%);
  opacity: 0;
  visibility: hidden;
  border-radius: 0 0 12px 12px;
  transition: all 300ms ease-in-out;
}

.show-overlay:before {
  opacity: 1;
  visibility: visible;
}

.item-wrapper {
  width: 466px;
  background: #fff;
  margin: 0 40px 40px 0;
  -webkit-box-shadow: 0 1px 2px rgb(43 59 93 / 29%);
  box-shadow: 0 1px 2px rgb(43 59 93 / 29%);
  /* cursor: pointer; */
  border-radius: 12px;
  transition: box-shadow 0.2s ease, transform 0.2s ease,
    -webkit-box-shadow 0.2s ease, -webkit-transform 0.2s ease;
  text-align: left;
  zoom: 0.7;
  padding: 25px;
  position: relative;
  border: 1px solid #ebecee;
  overflow: visible;
}

.item-wrapper:hover {
  box-shadow: 0px 12px 24px 0px rgb(0 0 0 / 20%);
  top: -4px;
  border-color: #fff;
}

.item-wrapper .flow-title {
  color: #424956;
  font-size: 30px;
  font-weight: 300;
  text-align: left;
  width: 100%;
  line-height: 45px;
  margin: 0;
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  outline: none;
  min-height: 45px;
}

p {
  margin: 0 30px;
}

.data-dz-thumbnail-bg-overlay:hover {
  opacity: 1;
}

.data-dz-thumbnail-bg-overlay {
  z-index: 5;
  top: 0;
  overflow: hidden;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  left: 0;
  height: 172px;
  width: 100%;
  position: absolute;
  top: 0;
  opacity: 0;
  background-color: rgba(25, 29, 38, 0.85);
  -webkit-transition: opacity 450ms ease-in-out;
  -o-transition: opacity 450ms ease-in-out;
  transition: opacity 450ms ease-in-out;
}

a.btn,
.work-flow-card-wrapper .footer button.btn,
.policy-request-buton.btn {
  font-family: brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  letter-spacing: 1px;
  line-height: 44px;
  transition: all 0.2s ease-in-out;
  z-index: 2;
  text-decoration: none;
  left: 0;
  right: 0;
  position: unset !important;
  top: 65px;
  width: fit-content;
  height: 47px;
  color: black;
  border: 1px solid #bdbfc5;
  border-radius: 5px;
  margin: 0;
  text-transform: none;
  font-size: 21px;
  font-weight: 300;
  padding: 0 18px 0px;
  display: inline-block;
  margin-right: 5px;
}

.work-flow-card-wrapper .footer button.disable-btn {
  color: #bdbfc5;
}
a.btn.edit-process {
  top: 70px;
}

a.btn:hover,
.policy-request-buton.btn:hover {
  background-color: rgb(39 39 42 / 5%);
}

.tools li.delete a {
  background-position: -129px -759px;
}

/*
.tools li.duplicate a {
  background-image: url("../assets/img/codelos-icons.svg");
  background-size: 32px 20px;
  background-position: -18px -3px;
}
*/
.tools li.leave a {
  background-image: url('../../assets/img/codelos-icons.svg');
  background-size: 32px 20px;
  background-position: -1px -3px;
}

.tools li img {
  transition: opacity 0.2s ease-in-out;
  -webkit-transition: opacity 0.2s ease-in-out;
  -o-transition: opacity 0.2s ease-in-out;
  padding: 6px;
  border-radius: 5px;
  width: 35px;
}

.tools li i {
  color: #505050;
  font-size: 20px;
  font-weight: 600;
  top: 2.4px;
  position: relative;
  padding: 6px;
}

.tools li img:hover,
.tools li i:hover {
  background-color: rgb(39 39 42 / 5%);
}

.tools {
  position: unset;
  border: 0px solid transparent;
  transition: visibility 0s ease 450ms, box-shadow 0.2s ease,
    -webkit-box-shadow 0.2s ease;
  margin-top: 0;
  width: fit-content;
  height: 29px;
  margin-bottom: 0;
  float: right;
}

.tools li {
  float: left;
  list-style: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  width: 35px;
  height: 35px;
}

.tools a {
  text-indent: -9999px;
}

.tools li > a {
  zoom: 1.2;
  opacity: 0.7;
  background-image: unset;
  background-size: unset;
  background-position: unset;
  width: 14px;
  height: 13px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  transition: opacity 0.2s ease-in-out;
  -webkit-transition: opacity 0.2s ease-in-out;
  -o-transition: opacity 0.2s ease-in-out;
}

.tools li > a:hover {
  opacity: 1;
}

.tools li.share a {
  background-position: -868px -268px;
}

.tools li.download a {
  background-position: -868px -646px;
}
.tools li.duplicate img,
.tools li.delete img,
.tools li.share img {
  margin: 0;
}
.work-flow-card-wrapper .tools li.download img {
  margin: 1px 0 0;
}
.work-flow-card-wrapper .tools li.embed img {
  margin: 1.5px 0 0;
}
.work-flow-card-wrapper .tools li.leave img {
  margin: -2px 0 0;
}
.tools li.iam i {
  color: rgb(194, 194, 194);
  font-size: 15px;
}

.tools li.delete a {
  background-position: -129px -759px;
}

.progress-icon {
  display: block;
  position: relative;
  left: auto;
  top: 108px;
  width: 70px;
  height: 70px;
}

.progress-icon {
  left: 152px;
}

.progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: progress-icon 1.2s linear infinite;
}

.progress-icon.dark-color:after {
  border-color: #1f2532 transparent #1f2532 transparent;
  width: 100px;
  height: 100px;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.zoom {
  width: 170px;
  position: relative;
  margin: unset;
  padding: unset;
  top: unset;
  bottom: unset;
  margin-top: 60px;
  margin-left: 73%;
}

.slider {
  appearance: none;
  -webkit-appearance: none;
  width: 100%;
  height: 15px;
  border-radius: 5px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  height: 2px;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #404755;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #404755;
  cursor: pointer;
}

.toolbar .share .link {
  background-image: url(../../assets/img/project-sprite.png);
  background-position: 0 -759px;
}

.option.round {
  border-radius: 50%;
  display: block;
  border: none;
  width: 60px;
  height: 60px;
  padding: 0;
  font-size: 18px;
  line-height: 60px;
  box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  background: #ffff;
  margin-top: 14px;
  color: #1f2532;
}

:v-deep .tooltip {
  top: 0;
  left: -500px;
  right: 600px;
  bottom: 0;
}

.content {
  margin: 0px 30px;
  -webkit-box-flex: 1;
  flex: 1;
  padding-top: 55px;
  padding-bottom: 55px;
  min-height: 264px;
}

.scrollable {
  min-height: 100%;
}

.header {
  width: 100%;
  height: 35px;
}

.footer {
  height: 52px;
}

.white-space {
  width: 100%;
  height: 0px;
  display: grid;
}
/* .custom-loader.show {
  opacity: 1 !important;
} */
.custom-loader {
  height: 100%;
  z-index: 1;
  opacity: 1 !important;
}
.data-dz-thumbnail-bg-overlay.custom-loader:hover {
  opacity: 0;
}

.custom-loader .progress-icon {
  left: 0;
  right: 0;
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);
  height: auto;
}
.data-dz-thumbnail-bg-overlay.custom-loader .progress-icon {
  left: 0 !important;
}

.custom-loader + .header {
  position: relative;
  z-index: 2;
}

.process-list-topbar {
  display: flex;
  -webkit-box-pack: end;
  justify-content: flex-end;
}

.menu3-bar .list-item {
  padding-left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
}

.menu3-bar .list-item > li {
  text-align: -webkit-match-parent;
  margin: 0 26px 0 0;
  vertical-align: top;
  display: inline-block;
  cursor: pointer;
}

.menu3-bar .list-item > li.item-mode-toggle {
  margin-top: 40px;
  font-size: 23px;
  color: #646f81;
}
.menu3-bar .list-item > li.add-folder {
  margin-top: 41px;
  font-size: 21px;
  color: #646f81;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-359deg);
  }
}
.refresh.rotation img {
  animation: rotation 1.5s infinite linear;
}

.refresh {
  padding-top: 7px;
  transition: all 0.2s ease-in-out;
}

.refresh:hover {
  transform: scale(1.1) rotate(0);
}

.checked.item-wrapper {
  box-shadow: 0 0 0 2px #1fc281;
}

/*bottom bar*/

.select-all-wrapper {
  float: right;
  margin-right: 100px;
  margin-top: 0;
  top: 30%;
  position: relative;
}

.btn-select-all {
  background-color: white;
  border-style: none;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  font-size: 16px;
  margin-left: 12.5px;
}

.toolbar .more .toggle-list-wrapper.toggle-up {
  margin-top: -100%;
  padding: 20px 0px 20px 0px;
  min-width: 195px;
  left: 0;
  top: 0;
}

.toggle-list-wrapper {
  background-color: #ffff;
  position: relative;
  left: -53px;
  top: 36px;
  -webkit-box-shadow: var(--elevation-high);
  box-shadow: var(--elevation-high);
  max-width: 600px;
  overflow: scroll;
  z-index: 2;
  border-radius: 3px;
  display: inline-block;
  clear: both;
  padding: 17px 0 17px 0;
  width: 226px;
  margin-top: 127px;
  margin-top: -47px;
}

.toolbar .more .toggle-list-wrapper.toggle-up .item {
  background: #fff;
  line-height: 36px;
  width: 100%;
  margin: 0;
  padding: 0 19px;
  margin-left: 7px;
  font-size: 14px;
}

.toolbar .more .toggle-list-wrapper.toggle-up .item:hover {
  background-color: #f0f0f0;
}

.toolbar .more .toggle-list-wrapper.toggle-up .item.more {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA4AAAAAhCAYAAACInMWBAAAAAXNSR0IArs4c6QAAAFBlWElmTU0AKgAAAAgAAgESAAMAAAABAAEAAIdpAAQAAAABAAAAJgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAADgKADAAQAAAABAAAAIQAAAAD9kkEtAAABWWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgpMwidZAAAGJElEQVR4Ae3cv4scVRwA8Jm9O+tgnUoQK7n2yhTiP5B/QATbBIscgiksgkiCSIKdIOlSxT9ALK5MJ8FGEayEdCGQztzt+L6bnSOZzLz9wczbLT4Lw86+737f93ufXebusXuvqtwIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQI7ItAvU0jP/z8+INZU31WN83Hkd/U9R/zunr45efX/1lnvl3nr9Oj54wn0DTN1TTb3XRcW856lu5P67r+d/k4e7fr/GxzgqMLPHny9Gq6ntyt6ubaYvKmPkvXm9OTk+Ps+6V03ug/uAnXEojrwatX87t1/fp60jTV2dHRbOX1pHTeWj+MJ40ucOPW7Q+b84Pvqrr6ZDF5U/1WH1589eDenb9zxUrn5XoRm07gwU+Pr746n6e/R5a/X6r67Ohwdnrji+vZ3y+l86YTMHNOoPTrvG293M+wbmzjBWAs3g7mzb2mrt57s0jdVP9dzOpbqxaBu85/s2fn0wssF29PU6X3O9Wep8fHqxaBu87v9OzhxAKxiGtmVe/7pZ5Xx0OLwNJ5EzOYfkAgrgfn5/On6f6t60m6jjw/PJwNXk9K5w20b3higZs3b380Pzh4kspc6ZR6Mbu4OLl//85fnfHFw9J5fT0Ym17g9R/bF73Xj6PDg+OhRWDpvOklVOgTKP06b1uvr/dtxmabJsUnf93FX8wRYxFbNd+u81f1Jz66QHzy99Yfa8sKMRaxVbdd56/qT3xEgcUnfwPvl2Wst1rpvN4mDE4uEJ/8dRd/UTTGIjbUQOm8oT6MTyswnx18myp0F39R9Moy1ttA6bzeJgxOLhCf/A1ePxafCva3UDqvvwujUwuUfp23rTeWw8YLwPZrn30N5GLt83PPycXGym/ncV9M4FqmUi7WpuWek4uNld/O476EQPu1z75a+xTr68/Y5ALt1z77Cu1TrK8/YwUE2q999pWqq0/7hhdjpfMGGxGYVqD92mdflX2K9fVnbHqBfXoP5HoZR2LjBeA4Zc1CgAABAgQIECBAgAABAqUFNl4AxoYvQ03mYm1O7jm52Fj57TzuiwmcZSrlYm1a7jm52Fj57TzuSwikDV8Gy+xTbLBJgSkFYsOXofn3KTbUo/GJBdKGL4MVmurXTKxs3mAjAtMKZH6/pM1ghmuXjg13IjKlQOnXedt64xhsvABM/2vzMDZ86ZaPsYh1x7uPd53f7cfjyQVOU4XY8KV7i7GIrbrtOn9Vf+IjCsRun2m63vfLMtZbrXRebxMGJxdY7vb5zvsjNoGJ2FADpfOG+jA+rUAzq79OFV70VHmxjPWE0v+QFs7rbcLg5AKx22dcK7qFFtePFOuOt49L57V13ZcVKP06b1tvLJWNF4Cxy2fs9llV9e9p0XceR5yvswNoNL3r/LHgzLOeQLqwxtbKx+l4lI5nyyPOB3fsS7HL267zLxtxUkQgdvmM3T7TpzmPmqp5tjjSeW4H0GisdF4RDEXeEYjrQez2mX7nPErnz+KI89wOoDFJ6bx3GjdQRODH77/5M3b7rJrql/Sqv1wc6TzGIjbUROm8oT6MTysQu3zGbp91Pbu8fsR5bgfQ6Kh03rQKZh8SKP06b1tvqH/jBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAEClwL/A0RbxXDyZfAlAAAAAElFTkSuQmCC);
  width: 30px;
  background-size: 368px 13px;
  background-repeat: no-repeat;
  background-position: 18px -2px;
}

.toggle-list-wrapper.toggle-up.toggle-right {
  position: absolute;
  left: 230px !important;
  margin-top: -100%;
  padding: 20px 0px 20px 0px;
  min-width: 195px;
}
.group-actions .toolbar li.item.more .toggle-right {
  font-size: 20px;
}

/*Search Input */
.search {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  cursor: auto;
}

.search img {
  width: 22px;
}

.filter-icon img {
  width: 20px;
}

.search-icon {
  cursor: pointer;
  padding-bottom: 2px;
}

.search input {
  border: 0;
  width: 0;
  margin-left: 5px;
  margin-top: 8px;
  cursor: initial;
  font-size: 18px;
  margin: 6px;
  -webkit-font-smoothing: antialiased;
  font-weight: 300;
  height: 100%;
  background: transparent;
  -webkit-transition: width 0.3s ease, border-color 0.3s ease;
  transition: width 0.3s ease, border-color 0.3s ease;
  outline: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.search.active {
  border-bottom: solid 2px rgb(255, 51, 102);
}

.search.active input {
  width: 230px;
}

.add-new-button-wrapper {
  position: relative;
  height: 140px;
  z-index: 1;
  width: 100%;
}

.add-new-button {
  text-align: center;
  display: block;
  cursor: pointer;
  color: white;
  border-radius: 6px;
  background-color: rgb(255, 51, 102);
  height: 60px;
  width: 114px;
  line-height: 59px;
  font-size: 23px;
  -webkit-box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  position: unset;
  top: 15px;
  transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
  float: right;
  margin-top: 45px;
  font-family: 'AktivGroteskMedium';
}

.add-new-button i {
  color: white;
  font-size: 18px;
  opacity: 0.5;
  padding: 5px;
  padding-right: 0px;
  border: none;
}

.add-new-button i:hover {
  opacity: 1;
}

.add-new-button:hover {
  -webkit-transform: scale(1.1) rotate(0);
  transform: scale(1.1) rotate(0);
}
.add-new-button-wrapper .dropdown-list-open {
  position: absolute;
  right: 0;
  top: 115px;
  border-radius: 4px;
  z-index: 10;
  text-align: center;
  cursor: pointer;
}

.process-list-container .filter-list-main-wrap {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
}

.filter-item-wrapper {
  display: flex;
  vertical-align: top;
  position: relative;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  gap: 9px;
}

.filter-item-wrapper .filter-item {
  font-size: 13px;
  border: solid 1px #cdcdcd;
  width: fit-content;
  min-width: 20px;
  border-radius: 6px;
  display: inline-block;
  color: #58647d;
  cursor: pointer;
  padding: 4px 8px;
  display: flex;
  align-items: center;
}

.filter-item span {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.filter-item i {
  width: 0;
  opacity: 0;
  position: relative;
}

.filter-item:hover {
  background-color: #f5f5f5;
}

.filter-item:hover .tag__wrapper i {
  width: 13px;
  opacity: 1;
  font-size: 13px;
  margin-left: 8px;
  color: #b5b5b5;
}

.filter-item i.fa-caret-down {
  font-size: 15px;
  opacity: 1;
  width: 10px;
  margin-left: 16px;
}

.filter-item:hover i:hover {
  color: black;
}

.filter-item-wrapper .filter-item .filter.dropdown.edit {
  position: fixed;
  display: block;
  margin-top: 140px;
  margin-left: -10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px 12px;
}

.filter-item-wrapper
  .filter-item
  .filter.dropdown.edit
  ::v-deep
  .dropdown
  .btn {
  width: 200px;
}

/* .filter-item-wrapper .filter-item .filter.dropdown.edit input {
  border: 1px solid #9398a3;
  margin-left: 10px;
  margin-right: 10px;
  height: 26px;
  padding: 1px;
} */

.item.filter-option.show-option {
  padding-bottom: 40px;
}

.key-filter select:focus {
  outline-width: 0;
}

.key-filter input:focus {
  outline-width: 0;
}

.key-filter .filter .tools i {
  font-size: 15px !important;
}

.filter.dropdown select,
input {
  border: none;
  display: inline-block;
  height: 36px;
  width: 119px;
  color: #000;
  font-size: 14px;
  text-align: center;
  padding: 6px 12px;
}

.filter.dropdown.edit select,
input {
  display: block;
  border-radius: 3px;
  text-align: left;
}

.filter.dropdown.add {
  top: 40px;
}
.filter.dropdown.add select,
input {
  display: inline-block;
}

.filter.dropdown.upload {
  width: 290px !important;
  padding: 39px !important;
  font-size: 14px !important;
  color: #4a556a !important;
  font-family: sans-serif !important;
  cursor: pointer !important;
  position: relative !important;
  margin-left: 0 !important;
  background-color: white !important;
  border: none !important;
  display: block !important;
  box-shadow: 0 0 15px -2px rgb(0 0 0 / 25%);
  z-index: 15;
  text-align: center !important;
}

.process-list-container .filter.dropdown {
  background-color: white;
  -webkit-box-shadow: 0 6px 20px -2px rgb(0 0 0 / 20%);
  box-shadow: 0 0 15px -2px rgb(0 0 0 / 25%);
  border-radius: 6px;
  position: absolute;
  z-index: 15;
  margin-left: 0;
  border: 1px solid #cdcdcd;
  padding: 12px 12px;
  display: flex;
}

.process-list-container .filter ::v-deep .dropdown-item {
  color: #58647d;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  border-radius: 3px;
  padding: 5px 10px;
  white-space: normal;
  width: 100% !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.process-list-container .filter ::v-deep li {
  list-style: none;
  padding: 0 7px;
}
.process-list-container .filter ::v-deep ul {
  padding: 7px 0;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.25);
  border: 1px solid #c0c0c0;
}
.process-list-container .filter ::v-deep li:hover {
  background-color: #ececec;
  border-radius: 5px;
}

.process-list-container .filter.dropdown.is-key-selected {
  padding: 32px 12px;
}

.process-list-container .filter-dropdown ::v-deep .customDropdown {
  border: 1px solid #cdcdcd;
  border-radius: 6px;
  justify-content: center;
  width: auto;
  min-width: 120px;
}
.process-list-container .filter-dropdown ::v-deep .customDropdown:hover {
  background: #cdcdcd !important;
}

.process-list-container .filter-dropdown ::v-deep .customDropdown .line-clamp {
  color: #58647d;
  margin-right: 8px;
  font-size: 13px;
  width: calc(100% - 20px);
}
.process-list-container
  .filter-dropdown
  ::v-deep
  .customDropdown
  .dropdown-toggle-icon {
  padding: 0 0 0 0;
}

.process-list-container .filter-margin-right {
  margin-right: 24px !important;
}

.process-list-container .filter-margin-left {
  margin-left: 24px !important;
}

.process-list-container .filter-input {
  border-radius: 6px;
  border: 1px solid #cdcdcd;
  margin: 0;
  height: 35px !important;
  min-width: 135px;
  font-size: 13px;
  color: #58647d;
  padding: 6px 12px;
  text-align: left;
  width: 119px;
}

.filter.dropdown hr {
  margin-top: 3px;
  background-color: #f0ebeb;
}

.filter.dropdown h2 {
  font-weight: 300;
  font-size: 22px;
  margin-bottom: 26px;
}

.filter.dropdown select {
  background: white;
}

/*for centered loader*/
.process-list {
  position: relative;
}

.progress-icon.dark-color.center:after {
  position: absolute;
  top: 0;
  left: 0;
  border: none;
}
.progress-icon.dark-color {
  left: 0;
  margin: 0 auto;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  border-radius: 9px;
  margin-top: 5px;
  box-sizing: border-box;
  padding: 20px;
  z-index: 3;
  cursor: pointer;
}
.group-list {
  display: block;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.group-list > span {
  display: block;
  padding: 8px 20px;
  background: #dfdfdf;
  border-radius: 4px;
  cursor: pointer;
}
.group-list.open > span i {
  transform: rotate(90deg);
}

.group-list > span i {
  margin-right: 20px;
  font-size: 16px;
  transition: all 300ms ease-in-out;
}
.group-list-wrapper {
  flex-wrap: wrap;
  padding: 15px;
  border: 1px solid #eee;
  display: none;
}
.group-list.open .group-list-wrapper {
  display: flex;
}
.add-new-button-wrapper .dropdown-list-open.unset-zIndex {
  z-index: 0;
}
p.message {
  position: absolute;
  right: 0;
  left: -10px;
  top: 35px;
  margin: 0 auto;
  display: block;
  color: green;
  font-size: 18px;
}

.embed {
  position: relative;
}
.action-top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  min-height: 30px;
}

.action-top-bar,
.add-new-button-wrapper {
  padding: 0px 10px;
}

.process-list-wrapper .code-tag-icon {
  zoom: 1.2;
}

::v-deep .toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
::v-deep .toast:not(.show) {
  display: block;
}

.action-top-bar .list-item .item a {
  line-height: 21px;
}

.process-list-container .filter.dropdown .initial-dropdown-items li {
  padding: 0;
}

.process-list-container .filter-dropdown .tag-item ::v-deep .dropdown-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.process-list-container .filter-dropdown .tag-item .tag-color-block {
  width: 10px;
  height: 10px;
  border-radius: 50px;
}

.process-list-container .worflow-tag-list-wrapper {
  position: relative;
}

.process-list-container .workflow-tag-list {
  display: flex;
  gap: 8px;
  font-size: 22px;
  align-items: center;
  flex-wrap: wrap;
}

.process-list-container .workflow-tag-list .workflow-tag {
  padding: 10px 15px;
  border-radius: 12px;
  color: black;
  max-width: 120px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
}

.process-list-container
  .filter-dropdown
  ::v-deep
  .dropdown-item
  .custom-control-input {
  width: 16px;
  min-width: 16px;
  min-height: 16px;
  margin-right: 10px;
  accent-color: #ff3366;
}

.process-list-container
  .filter-dropdown
  ::v-deep
  .dropdown-item
  .custom-checkbox {
  display: flex;
  padding: 0 10px 0 0;
  align-items: center;
}

.process-list-container .selected-filter-checkbox-options-wrap {
  width: calc(100% - 20px);
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.process-list-container .selected-filter-checkbox-item {
  display: inline-block;
  padding: 0 7px;
  background: #ececec;
  margin-right: 4px;
  border: 1px solid #cdcdcd;
  color: #58647d;
  font-size: 13px;
  height: 19px;
  line-height: normal;
  border-radius: 3px;
}

.process-list-container .checkbox-dropdown ::v-deep ul {
  padding: 7px 0;
  width: 220px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.2);
  border: none !important;
  margin-top: -3px !important;
}

.process-list-container .selected-filter-options-wrap {
  padding: 10px;
  margin: 0 10px;
  border: 1px solid #cdcdcd;
  border-radius: 6px;
  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  margin-bottom: 10px;
  max-height: 100px;
  overflow: auto;
}

.process-list-container .selected-filter-options-wrap .selected-filter-options {
  background: #ececec;
  border-radius: 3px;
  padding: 2px 6px;
  border: 1px solid #cdcdcd;
  color: #58647d;
  font-size: 12px;
  line-height: normal;
  display: flex;
  align-items: center;
  gap: 6px;
  max-width: max-content;
}
.process-list-container .selected-filter-options span {
  max-width: 100px;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.process-list-container .selected-filter-options-wrap .close-dropdown-icon {
  position: absolute;
  right: 30px;
  top: 11px;
}
.process-list-container
  .filter-dropdown
  ::v-deep
  .dropdown-item
  .custom-control-input
  label {
  cursor: pointer;
  font-size: 13px;
  color: #58647d;
}
.process-list-container .checkbox-dropdown {
  width: 220px;
  max-width: 100%;
}

.process-list-container .checkbox-dropdown ::v-deep .customDropdown {
  border-radius: 6px;
  justify-content: center;
  width: auto;
  min-width: 120px;

  border: 1px solid #cdcdcd;
}
.process-list-container .show.checkbox-dropdown ::v-deep .customDropdown {
  border: none !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
}
.process-list-container .checkbox-dropdown .selected-filter-options ::v-deep i {
  color: #a6a6a6;
  font-size: 12px;
  margin-left: 5px;
  display: inline-block;
  opacity: 1;
  width: auto;
}
.process-list-container
  .checkbox-dropdown
  .selected-filter-options
  ::v-deep
  i:hover {
  color: #000;
}
.process-list-container .checkbox-dropdown .custom-checkbox {
  width: 100%;
  max-width: 100%;
  padding: 0 10px !important;
}
.process-list-container
  .checkbox-dropdown
  .dropdown-item
  .custom-checkbox:hover {
  background-color: #f0f0f0 !important;
  color: #212529 !important;
  border-radius: 4px !important;
  transition: 0.5s ease-in-out all;
}
.process-list-container .checkbox-dropdown .tag-item {
  padding: 0 10px !important;
}
.process-list-container .checkbox-dropdown .tag-item:hover {
  background-color: transparent !important;
}
.process-list-container
  .checkbox-dropdown
  ::v-deep
  .custom-checkbox
  .custom-control-label {
  display: flex;
  width: 100%;
  max-width: 100%;
  align-items: center;
  justify-content: space-between;
  cursor: pointer !important;
}
.process-list-container .checkbox-dropdown ::v-deep .close-dropdown-icon {
  opacity: 1;
  font-size: 13px;
  margin-left: auto;
  color: #b5b5b5;
}
.process-list-container .checkbox-dropdown ::v-deep .close-dropdown-icon:hover {
  color: #000;
}
.process-list-container .filter-item:hover {
  max-width: 224px;
}

.process-list-container .process-list-item-loader {
  background-color: #fff;
}

.process-list-container .process-list-item-loader .progress-icon {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: -16px;
  padding: 0;
}
.process-list-container .confirm-message-wrapper {
  max-width: 400px;
  margin-bottom: 24px;
}

.process-list-container .confirm-message {
  color: #212529;
  font-size: 16px;
  margin: 0;
  /* text-align: center; */
}

.process-list-container ::v-deep .common-modal .modal-inner .buttons {
  line-height: 28px;
}

.process-list-container .custom-add-tags {
  width: 45px;
  height: 45px;
  background-color: rgba(220, 220, 220, 0.36);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.process-list-container .custom-add-tags img {
  width: 20px;
  height: 20px;
  filter: invert(97%) sepia(9%) saturate(0%) hue-rotate(34deg) brightness(92%)
    contrast(88%);
}

.process-list-container .custom-add-tags:hover {
  background-color: rgba(124, 124, 124, 0.36);
}

.process-list-container .custom-add-tags:hover img {
  filter: invert(100%) sepia(0%) saturate(7495%) hue-rotate(242deg)
    brightness(97%) contrast(97%);
}

.process-list-container .add-tag-modal-wrapper {
  width: 100%;
  height: 100%;
  padding: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute !important;
  top: 0;
  left: 0;
}

.process-list-container .custom-modal-footer .footer-wrap {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.process-list-container .custom-modal-footer .footer-wrap button {
  min-width: 100px;
  background-color: #191f25;
  color: #fff;
  font-size: 20px;
  line-height: 24.52px;
  padding: 0 18px;
  border-radius: 10px;
  height: 47px;
}

.process-list-container .form-item input {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 8px 15px;
  width: 100%;
  height: auto;
  box-sizing: border-box;
}

.process-list-container .custom-multiselect {
  position: relative;
  box-sizing: border-box;
}

.process-list-container .custom-multiselect.open {
  border-radius: 4px;
  overflow: hidden;
}

.process-list-container .custom-multiselect .custom-multiselect-list {
  padding: 0 12px !important;
  background: #fff;
  display: none;
}
.process-list-container .custom-multiselect .custom-multiselect-list.open {
  display: block;
}
.process-list-container .custom-modal-footer {
  padding: 0 25px 25px;
}
.process-list-container .custom-multiselect-list-item-wrapper {
  max-height: 257px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  margin: 12px 0;
}

.custom-multiselect-wrap:has(
    .custom-multiselect-list-wrap .custom-multiselect-list-item
  )
  .custom-multiselect-list-item-wrapper {
  height: 186px !important;
}
.process-list-container .custom-multiselect .custom-multiselect-wrap {
  display: flex;
  flex-direction: column;
  min-width: 180px;
  max-width: calc(100vw - 24px);
  height: 100%;
  max-height: 70vh;
}

.process-list-container .custom-multiselect * {
  box-sizing: border-box;
}

.process-list-container .custom-multiselect .custom-selected-tags {
  max-height: 240px;
  overflow: hidden auto;
  margin-right: 0px;
  margin-bottom: 0px;
}
.process-list-container .custom-multiselect .custom-selected-tags-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  cursor: text;
  overflow: auto;
  width: 100%;
  font-size: 14px;
  margin-right: 0px;
  margin-bottom: 0px;
  border: 1px solid #eee;
  border-radius: 10px 10px 0 0;
  padding: 18px 15px;
  gap: 10px;
  background-color: #f5f5f7;
  height: 120px;
}

.process-list-container .custom-multiselect .custom-selected-item {
  display: flex;
  align-items: center;
  flex-shrink: 1;
  padding: 8px 12px;
  font-weight: 500;
  font-size: 20px;
  line-height: 24.52px;
  border-radius: 8px;
}

.process-list-container .custom-multiselect .custom-selected-item span {
  display: flex;
  align-items: center;
}

.process-list-container .custom-multiselect .custom-selected-item i {
  user-select: none;
  transition: background 20ms ease-in 0s;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 0;
  flex-shrink: 0;
  margin-left: 2px;
  margin-right: 2px;
  width: 20px;
  height: 20px;
}
.process-list-container .custom-multiselect .custom-selected-item.input,
.process-list-container .custom-multiselect .custom-selected-item.input input {
  background-color: #f5f5f7 !important;
  outline: none;
}

.process-list-container .custom-multiselect .custom-selected-item.input input {
  font-size: 20px;
  line-height: 24.52px;
  border: none;
  background: none;
  width: 100%;
  display: block;
  resize: none;
  padding: 0px;
  margin-bottom: 0;
  cursor: text;
  height: 39px;
}

.process-list-container .custom-multiselect .custom-selected-item.input {
  display: flex;
  align-items: center;
  border: none;
  padding: 0px;
  width: auto;
  background: transparent;
  font-size: inherit;
  line-height: 20px;
  flex: 1 1 60px;
  min-width: 60px;
  margin: 0px 6px 0 0px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.process-list-container .custom-multiselect .custom-multiselect-list-item {
  display: flex;
  flex-direction: row;
  margin: 8px 12px;
  cursor: pointer;
  transition: all 300ms ease-in-out;
  padding: 5px 12px;
  justify-content: space-between;
}

.process-list-container
  .custom-multiselect
  .custom-multiselect-list-item-wrapper
  .custom-multiselect-list-item-inner,
.process-list-container
  .custom-multiselect
  .custom-multiselect-list-item-wrapper
  .custom-multiselect-list-item-inner:hover,
.process-list-container
  .custom-multiselect
  .custom-multiselect-list
  .custom-multiselect-list-item-wrapper
  .custom-multiselect-list-item {
  background-color: transparent;
  margin: 0;
  color: inherit;
  padding: 0;
}
.process-list-container
  .custom-multiselect
  .custom-multiselect-list-item-wrapper
  .custom-multiselect-list-item {
  margin: 0;
}
.work-flow-card-wrapper
  .process-list-container
  .custom-multiselect
  .custom-multiselect-list-item-wrapper
  .custom-multiselect-list-item:hover {
  background-color: #f3f3f3;
}

.work-flow-card-wrapper
  .custom-multiselect-list-item-wrapper
  .custom-multiselect-list-item:hover
  .edit-action-icon
  .ellipsis-icon {
  opacity: 1;
}

.process-list-container
  .custom-multiselect
  .custom-multiselect-list
  .custom-multiselect-list-item {
  display: flex;
  flex-direction: column;
  margin: 12px 0 0 0;
  cursor: pointer;
  transition: all 300ms ease-in-out;
  background-color: #f9f9f9;
  border-radius: 10px;
}
.process-list-container .custom-multiselect-list-item:hover {
  background: #f0f0f0;
}
.process-list-container .custom-multiselect-list-item.select-div-visible:hover {
  background: none !important;
}

.process-list-container
  .custom-multiselect
  .custom-multiselect-list-item-inner {
  background-color: #f9f9f9;
  border-radius: 12px;
  padding: 16px;
  word-break: break-word;
  white-space: unset;
  max-width: 100%;
  text-overflow: unset;
}

.process-list-container
  .custom-multiselect
  .custom-multiselect-list-item-inner:hover {
  background-color: #d1d1d1;
}
.process-list-container
  .custom-multiselect
  .custom-multiselect-list-item-inner:hover
  span {
  color: #fff;
}
.process-list-container
  .custom-multiselect
  .custom-multiselect-list-item-inner
  span {
  font-weight: 500;
  font-size: 20px;
  color: #929292;
  border-radius: 12px;
}

.process-list-container
  .custom-multiselect
  .custom-multiselect-list-item-wrapper
  .custom-multiselect-list-item-inner
  span {
  font-weight: 500;
  border-radius: 6px;
  font-size: 20px;
  padding: 10px 15px;
  color: #929292;
  background-color: #f9f9f9;
  border-radius: 12px;
  display: inline-block;
}

.process-list-container .colors-tags-list-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 10px;
  margin-top: 3px;
}
.process-list-container
  .custom-multiselect-list-item-inner:has(.colors-tags-list-wrapper),
.custom-multiselect-list-item-inner:has(.colors-tags-list-wrapper):hover {
  background: #eaeaea;
  color: #fff;
  height: 60px;
}

.process-list-container .colors-Tag-list-item {
  width: 23px;
  height: 23px;
  border-radius: 7px;
  position: relative;
}
.work-flow-card-wrapper
  .colors-tags-list-wrapper
  .colors-Tag-list-item.selected-color {
  border: 1.5px solid #92bdff;
}
.work-flow-card-wrapper .colors-tags-list-wrapper .colors-Tag-list-item {
  cursor: pointer;
}
.process-list-container .colors-Tag-list-item:before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  border-radius: 5px;
  border: 1px solid transparent;
  transition: 0.5s;
}
.process-list-container .colors-Tag-list-item:hover:before {
  border: 1px solid #fff;
}
.process-list-container .colors-Tag-list-item.active:before {
  border: 1px solid #fff;
}

.process-list-container .add-tag-modal-wrapper .loading-container {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 10;
}
.process-list-container .add-tag-modal-wrapper .loading-container .loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.process-list-container
  .add-tag-modal-wrapper
  .loading-container
  .loading
  ::v-deep
  .progress-icon-wrapper {
  position: unset !important;
  margin: 0px !important;
}
.work-flow-card-wrapper .tag-overlay {
  position: fixed;
  background: rgb(0 0 0 / 20%);
  inset: 0;
  content: '';
  z-index: 2;
}

.process-list-container .item-wrapper .modal-inner.tag-modal-inner-open {
  position: relative;
  z-index: 3;
  background: #fff;
  border-radius: 12px;
}
.process-list-container .tag-wrapper {
  display: flex;
  gap: 8px;
  margin: 25px 0 0 0;
  flex-wrap: wrap;
}

.process-list-container .process-list-wrapper .tag-overlay .main-title {
  -webkit-line-clamp: unset;
}

.process-list-container .process-list-wrapper .tag-overlay .workflow-tag {
  word-break: break-word;
  white-space: unset;
  max-width: 100%;
  text-overflow: unset;
}
.process-list-container .card .workflow-tag .remove-tag-icon {
  display: none;
}

.process-list-container .card .workflow-tag:hover .remove-tag-icon {
  display: flex;
  align-items: center;
  cursor: pointer;
  opacity: 1;
  position: absolute;
  width: 80%;
  height: 100%;
  right: 0;
  top: 0;
  justify-content: end;
  border-radius: 10px;
}

.process-list-container .card .workflow-tag .remove-tag-icon i {
  margin-right: 7px;
  color: #808080;
}
.process-list-container .tag-modal-close {
  align-self: flex-start;
}
.process-list-container .custom-selected-item.selected-item {
  word-break: break-word;
  white-space: unset;
  max-width: 100%;
  text-overflow: unset;
}

.item-wrapper:hover .tag-wrapper .workflow-tag {
  white-space: unset;
  text-overflow: unset;
  overflow: unset;
  max-width: max-content;
  word-break: break-all;
}

.item-wrapper:hover .content h1 {
  overflow: unset;
  display: unset;
}

.item-wrapper .header input[type='checkbox'] {
  cursor: pointer;
  visibility: visible;
  height: 25px;
  width: 16px;
  display: inline-block;
  background: 0 0;
  margin-bottom: 0;
  accent-color: #0fbf00;
  margin-right: 0;
  top: 2.4px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 3px;
  position: relative;
  border: 0.5px solid #a9a9a9;
  box-shadow: -0.5px 0.5px 2px 0.5px #00000024 inset;
  border-radius: 100%;
}

.item-wrapper .header input[type='checkbox']:checked {
  background-color: #0fbf00;
  opacity: 1;
  pointer-events: auto;
}

.item-wrapper .header input[type='checkbox']:checked::before {
  content: '';
  position: absolute;
  top: 47%;
  left: 50%;
  width: 10px;
  height: 6px;
  border-left: 2px solid white;
  border-bottom: 2px solid white;
  transform: translate(-50%, -50%) rotate(-45deg);
}

.item-wrapper .header input[type='checkbox']:focus-visible {
  outline: none;
}
.work-flow-card-wrapper .item-wrapper.tag-modal-open:hover {
  box-shadow: 0 1px 2px rgb(43 59 93 / 29%);
  border: 1px solid #ebecee;
  top: 0;
}
.work-flow-card-wrapper .item-wrapper .header input[type='checkbox'] {
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.3s;
}
.work-flow-card-wrapper:hover .item-wrapper .header input[type='checkbox'] {
  opacity: 1;
  pointer-events: auto;
}

.work-flow-card-wrapper
  .inside-tag-list-item
  .custom-multiselect-list-item-inner {
  width: calc(100% - 24px);
}

.work-flow-card-wrapper .inside-tag-list-item .edit-action-icon {
  width: 44px;
  min-width: 24px;
  height: 44px;
  display: flex;
  max-width: 100%;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}

.work-flow-card-wrapper .inside-tag-list-item .edit-action-icon:hover {
  background-color: #e1e1e1;
}

.work-flow-card-wrapper .inside-tag-list-item .edit-action-icon i {
  font-size: 22px;
  color: #9f9e9c;
  opacity: 0;
  transition: all 0.3s ease;
}

.work-flow-card-wrapper .edit-dropdown {
  padding: 4px;
  position: absolute;
  width: 100%;
  bottom: 0;
  right: 0;
  background-color: #fff;
  z-index: 6;
  border-radius: 6px;
  height: fit-content;
}
.work-flow-card-wrapper .edit-dropdown .edit-dropdown-inner {
  width: 100%;
  max-width: 100%;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  padding: 2px;
  background-color: #fff;
}

.work-flow-card-wrapper
  .edit-dropdown
  .edit-dropdown-inner
  .edit-dropdown-input {
  width: 100%;
  max-width: 100%;
}

.work-flow-card-wrapper
  .edit-dropdown
  .edit-dropdown-inner
  .edit-dropdown-input
  input {
  border: none;
  outline: none;
  border-radius: 6px;
  background-color: #f0f0f0;
  padding: 8px 15px;
  font-weight: 500;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0;
  color: #333343;
  width: 100%;
  max-width: 100%;
  height: 50px;
  cursor: text;
}
.work-flow-card-wrapper
  .edit-dropdown
  .edit-dropdown-inner
  .edit-dropdown-input
  input.invalid-input {
  border: 1px solid red;
}

.work-flow-card-wrapper
  .edit-dropdown
  .edit-dropdown-inner
  .edit-dropdown-bottom {
  padding: 0 18px;
}

.work-flow-card-wrapper
  .edit-dropdown
  .edit-dropdown-inner
  .edit-dropdown-bottom
  .remove-button-wrapper {
  font-weight: 600;
  font-size: 20px;
  line-height: 36px;
  letter-spacing: 0;
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: start;
  color: #3b3b5cad;
  border-bottom: 1px solid #e6e6e6;
  height: 55px;
}
.work-flow-card-wrapper
  .edit-dropdown
  .edit-dropdown-inner
  .edit-dropdown-bottom
  .remove-button-wrapper
  .remove-button {
  cursor: pointer;
}
.work-flow-card-wrapper
  .edit-dropdown
  .edit-dropdown-inner
  .edit-dropdown-bottom
  .remove-button-wrapper
  i {
  font-size: 20px;
  color: #3b3b5cad;
}

.work-flow-card-wrapper
  .edit-dropdown
  .edit-dropdown-inner
  .edit-dropdown-bottom
  .color-checkbox {
  padding: 0 0 20px;
}
.work-flow-card-wrapper
  .edit-dropdown
  .edit-dropdown-inner
  .edit-dropdown-bottom
  .color-checkbox
  p {
  font-weight: 600;
  font-size: 20px;
  line-height: 36px;
  letter-spacing: 0;
  color: #3b3b5cad;
  margin: 0;
  padding: 12px 0 5px 0;
}
.work-flow-card-wrapper .card .footer ::v-deep .edit-button-tooltip {
  position: absolute;
  transform: unset !important;
  top: unset !important;
  bottom: 100px !important;
  left: 25px !important;
  border-radius: 7px;
  opacity: 1;
  background: #1e1e1e;
  box-shadow: 0px 0px 5px 3px rgba(0, 0, 0, 0.15);
}
.work-flow-card-wrapper
  .card
  .footer
  ::v-deep
  .edit-button-tooltip
  .tooltip-inner {
  color: #e8e8e8;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  min-width: 250px;
  line-height: normal;
  padding: 35px 25px;
}
</style>
